// extracted by mini-css-extract-plugin
export var header = "_ug-1";
export var maskBottom = "_ug-6";
export var maskMiddle = "_ug-7";
export var maskTop = "_ug-5";
export var root = "_ug-0";
export var scrollDownButton = "_ug-3";
export var scrollDownButtonHidden = "_ug-4";
export var viewport = "_ug-2";